"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_VARIANTS = exports.COLORS = void 0;
const ramda_1 = require("ramda");
const BASE_COLORS = {
    brown: [
        '#B83A18',
        '#D95027',
        '#F77036',
        '#FBB59D',
        '#FFDACC',
        '#FFEBE0',
        '#FFF3F0',
        '#FFFCFB',
    ],
    ctaBlue: [
        '#0D5ABF',
        '#0C6CF3',
        '#5CA3FF',
        '#A8D4FF',
        '#D1E8FF',
        '#E2F0FD',
        '#F1F7FD',
        '#FAFDFF', // backgroundActionableDisabled
    ],
    green: [
        '#3A8D42',
        '#48B14E',
        '#76ED7C',
        '#BAFCBD',
        '#DDFDDD',
        '#E5FFE7',
        '#F0FFF0',
        '#FBFFFB',
    ],
    grey: [
        '#17294D',
        '#455980',
        '#8090B2',
        '#B1BACC',
        '#EDEEF1',
        '#F3F5F6',
        '#F9FAFB',
        '#FCFDFE', // backgroundLightGray
    ],
    lightBlue: [
        '#1476BD',
        '#0E91E1',
        '#52BCFF',
        '#A8DEFF',
        '#D2EEFF',
        '#E5F5FF',
        '#F0F9FF',
        '#FAFDFF',
    ],
    magenta: [
        '#9E1878',
        '#C936A6',
        '#E85FCC',
        '#F3A9E4',
        '#FBD7F4',
        '#FFE5FF',
        '#FFF0FD',
        '#FFFCFF',
    ],
    orange: [
        '#C26604',
        '#E38016',
        '#FFA238',
        '#FFD39F',
        '#FFEBD1',
        '#FFF2E0',
        '#FFF7F0',
        '#FFFDFB',
    ],
    pink: [
        '#B31E50',
        '#DA2B65',
        '#F7578C',
        '#FBABC6',
        '#FDD7E3',
        '#FFE5EE',
        '#FDF1F5',
        '#FFFCFD',
    ],
    premiumPink: [
        '#E74E36',
        '#EA6F5D',
        '#F39182',
        '#FEA99A',
        '#FFD2C7',
        '#FFE2D9',
        '#FFF0EB',
        '#FFF8F5',
    ],
    purple: [
        '#7229B3',
        '#9343D9',
        '#B45EFF',
        '#DAB0FF',
        '#EDD9FF',
        '#F3E5FF',
        '#F7F0FF',
        '#FEFCFF',
    ],
    red: [
        '#B52430',
        '#DB394C',
        '#F05B60',
        '#F7ADAF',
        '#FBD6D7',
        '#FCE4E6',
        '#FDF1F2',
        '#FFFCFC',
    ],
    turquoise: [
        '#068E70',
        '#07B58E',
        '#13F0C0',
        '#99FBE6',
        '#D3FDF3',
        '#E3FDF8',
        '#ECFDF9',
        '#FAFFFD',
    ],
    white: [
        '#FFFFFF',
        '#FFFFFF',
        '#FFFFFF',
        '#FFFFFF',
        '#FFFFFF',
        '#FFFFFF',
        '#FFFFFF',
        '#FFFFFF',
    ],
    yellow: [
        '#B57C08',
        '#E5B301',
        '#FFD947',
        '#FFEB9F',
        '#FFF5CC',
        '#FFF7DB',
        '#FFFBEB',
        '#FFFEF9',
    ],
};
// Exporting the full list of colors and colorVariants makes it easier to
// list all available values in StoryBook.
exports.COLORS = Object.keys(BASE_COLORS);
exports.COLOR_VARIANTS = [-2, -1, 0, 1, 2, 3, 4, 5];
const mapColorVariationsToColorScale = (array) => (index) => array[index + 2];
const colors = (0, ramda_1.mapObjIndexed)(mapColorVariationsToColorScale, BASE_COLORS);
exports.default = colors;
